export default {
  path: '/servico-av/:id/resumo',
  component: () => import('@/components/views/AVServiceSummary')
}
